import { FC } from "react";
import { LikesBoxContainer } from "./Styles";
import { Colors, FInter, FlexBox } from "@brg/ui";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import LikesIcon24Fill from "shared/assets/24/LikesIcon24Fill";
import LikesIcon24Empty from "shared/assets/24/LikesIcon24Empty";

export enum LikesBoxSize {
  small = "small",
  medium = "medium",
  large = "large",
}

export interface LikesBoxProps {
  isInteractive?: boolean;
  isLiked?: boolean;
  likes: number;
  size?: LikesBoxSize;
  isBlackTheme?: boolean;
  onClick?: () => void;
  project?: any
}

const LikeIconWrapper = styled.div<{ isBlackTheme?: boolean }>`
  margin-right: 8px;
  svg * {
    fill: ${({theme, isBlackTheme}) => isBlackTheme ? Colors.geoWhite100 : theme.app.text};
  }
`

const LikesInnerWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 20px;
    width: 20px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      height: 16px;
      width: 16px;
    }
`

const LikesBoxCount = styled.div`
  color: ${Colors.geoWhite100};
  margin-bottom: -3px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 11px;
    line-height: 13px; 
  }
`

const CountNoGrid = styled(FInter.SmallTextDiv)`
  margin-bottom: -3px;
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

/**
 * **LikesBox** - отображает сердце и цифру рядом. Руководит закрашиванием сердца и всеми его состояниями.
 * Конвертирует кол-во 1000 в 1к и тд. Имеет 3 размера: Small, Medium и Large.
 *
 * @param props
 */
export const LikesBox: FC<LikesBoxProps> = (props) => {
  const { isInteractive, isLiked, likes, onClick, isBlackTheme } = props;
  const isDoubleGrid = useIsDoubleGrid();
  const theme = useTheme();

  const onClickHandler = () => {
    if (isInteractive) {
      onClick?.()
    }
  };

  return (
    <LikesBoxContainer
      onClick={(e) => {
        e.preventDefault();
        onClickHandler();
      }}
      gx={6}
      isLiked={isLiked}
      isInteractive={isInteractive}
    >
      {!isDoubleGrid && (
        <FlexBox align="center">
          <LikeIconWrapper isBlackTheme={isBlackTheme}>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={isBlackTheme ? Colors.geoWhite100 :Colors.galBlack47}/>
              )}

          </LikeIconWrapper>
          <CountNoGrid color={theme.app.text}>
            <div>{likes}</div>
          </CountNoGrid>
        </FlexBox>
      )}
      {isDoubleGrid && (
        <>
          <LikesInnerWrapper>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={isBlackTheme ? Colors.geoWhite100 : Colors.galBlack47} />
              )}
          </LikesInnerWrapper>
          <LikesBoxCount>
            <div>{likes}</div>
          </LikesBoxCount>
        </>
      )}
    </LikesBoxContainer>
  );
};
import { FC } from "react";
import { LikesBoxContainer } from "./Styles";
import { Colors, FInter, FlexBox } from "@brg/ui";
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import LikesIcon24Fill from "shared/assets/24/LikesIcon24Fill";
import LikesIcon24Empty from "shared/assets/24/LikesIcon24Empty";

export enum LikesBoxSize {
  small = "small",
  medium = "medium",
  large = "large",
}

export interface LikesBoxProps {
  isInteractive?: boolean;
  isLiked?: boolean;
  likes: number;
  size?: LikesBoxSize;
  isBlackTheme?: boolean;
  onClick?: () => void;
  project?: any
}

const LikeIconWrapper = styled.div<{ isBlackTheme?: boolean }>`
  margin-right: 8px;
  svg * {
    fill: ${({theme, isBlackTheme}) => isBlackTheme ? Colors.geoWhite100 : theme.app.text};
  }
`

const LikesInnerWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 20px;
    width: 20px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      height: 16px;
      width: 16px;
    }
`

const LikesBoxCount = styled.div`
  color: ${Colors.geoWhite100};
  margin-bottom: -3px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px; 

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 11px;
    line-height: 13px; 
  }
`

const CountNoGrid = styled(FInter.SmallTextDiv)`
  margin-bottom: -3px;
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`

/**
 * **LikesBox** - отображает сердце и цифру рядом. Руководит закрашиванием сердца и всеми его состояниями.
 * Конвертирует кол-во 1000 в 1к и тд. Имеет 3 размера: Small, Medium и Large.
 *
 * @param props
 */
export const LikesBox: FC<LikesBoxProps> = (props) => {
  const { isInteractive, isLiked, likes, onClick, isBlackTheme } = props;
  const isDoubleGrid = useIsDoubleGrid();
  const theme = useTheme();

  const onClickHandler = () => {
    if (isInteractive) {
      onClick?.()
    }
  };

  return (
    <LikesBoxContainer
      onClick={(e) => {
        e.preventDefault();
        onClickHandler();
      }}
      gx={6}
      isLiked={isLiked}
      isInteractive={isInteractive}
    >
      {!isDoubleGrid && (
        <FlexBox align="center">
          <LikeIconWrapper isBlackTheme={isBlackTheme}>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={isBlackTheme ? Colors.geoWhite100 :Colors.galBlack47}/>
              )}

          </LikeIconWrapper>
          <CountNoGrid color={theme.app.text}>
            <div>{likes}</div>
          </CountNoGrid>
        </FlexBox>
      )}
      {isDoubleGrid && (
        <>
          <LikesInnerWrapper>
            {isLiked ? (
                <LikesIcon24Fill fill={Colors.geoWhite100} />
              ) : (
                <LikesIcon24Empty fill={isBlackTheme ? Colors.geoWhite100 : Colors.galBlack47} />
              )}
          </LikesInnerWrapper>
          <LikesBoxCount>
            <div>{likes}</div>
          </LikesBoxCount>
        </>
      )}
    </LikesBoxContainer>
  );
};
